// src/pages/Cyberware.js

import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import AddCartButton from '../components/AddCartButton';

const Cyberware = ({ cart, setCart }) => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState('All');

  useEffect(() => {
  fetch(process.env.PUBLIC_URL + '/ProductData.csv')
      .then(response => response.text())
      .then(data => {
        let parsedData = Papa.parse(data, { header: true, dynamicTyping: true }).data;
        // Only keep products with category 'book' (case-insensitive)
        parsedData = parsedData.filter(product => (product.category || '').toLowerCase() === 'Cyberware');
        parsedData.forEach(product => {
          if (product.images) {
            product.images = product.images.split('|').map(image => image.trim());
          } else {
            product.images = [];
          }
        });
        setProducts(parsedData);
        setFilteredProducts(parsedData);
      })
      .catch(error => {
        console.error('Error fetching or parsing CSV file:', error);
      });
  }, []);

  const addToCart = (item) => {
    const existingIndex = cart.findIndex(
      cartItem => cartItem.id === item.id && cartItem.type === item.type
    );
    let updatedCart;
    if (existingIndex !== -1) {
      // Increment quantity for existing item
      updatedCart = cart.map((cartItem, idx) =>
        idx === existingIndex
          ? { ...cartItem, quantity: (cartItem.quantity || 1) + 1 }
          : cartItem
      );
    } else {
      // Add new item with quantity 1
      updatedCart = [...cart, { ...item, quantity: 1 }];
    }
    setCart(updatedCart);
  };

  // Get all unique genres for filter
  const genres = Array.from(new Set(products.map(product => product.genre))).filter(Boolean);

  const handleGenreChange = (genre) => {
    setSelectedGenre(genre);
    if (genre === 'All') {
      setFilteredProducts(products);
    } else {
      setFilteredProducts(products.filter(product => product.genre === genre));
    }
  };

  return (
    <div>
      <div className='main'>
        {/* Left column: genre filter */}
        <div className="column1">
          <h2 className="filter-heading">Genres</h2>
          <ul className="filter-list">
            <li className="filter-category" onClick={() => handleGenreChange('All')}>All Cyberware</li>
            {genres.map(genre => (
              <li key={genre} className="filter-category" onClick={() => handleGenreChange(genre)}>{genre}</li>
            ))}
          </ul>
        </div>
        {/* Center column: Cyberware grid */}
        <div className="column2 catalog-grid">
          <div className="catalog-title">
            <h1>{selectedGenre === 'All' ? 'All Cyberware' : selectedGenre}</h1>
          </div>
          <div className="catalog-grid-row">
            {filteredProducts.map(product => (
              <div key={product.id} className="product-card">
                <h3 className="product-title">{product.name}</h3>
                <p className="product-description">{product.description}</p>
                <div className="product-image-wrapper">
                  {product.images && product.images.map((image, index) => (
                    <React.Fragment key={index}>
                      <img
                        src={process.env.PUBLIC_URL + image}
                        alt={`${product.name} ${index + 1}`}
                        className="product-img"
                      />
                      <br />
                    </React.Fragment>
                  ))}
                </div>
                <div className="product-details">
                  <strong className="product-type">{product.type}</strong>: {product.price} AUD
                  <br />
                  ISBN: {product.isbn}
                  <br />
                  Publisher: {product.publisher}
                  <br />
                  Language: {product.language}
                  <br />
                  Trim Size: {product.trim}
                  <br />
                  Page Count: {product.pageCount}
                  <br />
                  Publication Date: {product.publicationDate}
                  <br />
                  Audience: {product.audience}
                  <br />
                  Genre: {product.genre}
                </div>
                <AddCartButton
                  item={product}
                  onAddToCart={addToCart}
                />
              </div>
            ))}
          </div>
        </div>
        {/* No third column */}
      </div>
    </div>
  );
};

export default Cyberware;